import FileView from './FileView'
import {FileViewProps} from './types'
import React from 'react'

const File = (props: FileViewProps): React.ReactElement => <FileView {...props} />
export default File
